import React from 'react';
import '../survey-hub.css';

type Stat = [string, string];

interface Props {
  title: string;
  description: string;
  stats?: Stat[];
  kicker?: string;
}

const DEFAULT_STATS: Stat[] = [
  ['14', 'типов / шагов'],
  ['390px', 'мобильная ширина'],
  ['0', 'пустых кнопок'],
  ['1.71', 'версия'],
];

export const SurveyHubHero: React.FC<Props> = ({
  title,
  description,
  stats = DEFAULT_STATS,
  kicker = 'Zertteu Academy · кабинет владельца',
}) => (
  <section className="survey-hub-hero">
    <div className="survey-hub-hero-main">
      <span className="survey-hub-kicker">{kicker}</span>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
    <div className="survey-hub-hero-side">
      {stats.map(([value, label]) => (
        <div key={label} className="survey-hub-stat">
          <b>{value}</b>
          <span>{label}</span>
        </div>
      ))}
    </div>
  </section>
);
